module.exports = __webpack_public_path__ + "static/media/Administracion2.83790c2.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audios/Administracion2.mp3
// module id = 709
// module chunks = 1